module.exports = __webpack_public_path__ + "static/img/discomfort-01.879ca82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/discomfort-01.jpg
// module id = 262
// module chunks = 1